module.exports = __webpack_public_path__ + "img/title-3.698d3a6f.png";